import {inlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import {UserRequestsFactory} from '../../user/Requests/factory.js'
import UserServicesFactory from '../../user/Services/factory.js'
import {DraftMappersFactory} from '../Mappers/factory.js'
import {DraftServicesFactory} from '../Services/factory.js'

export class PublishAdPublisherUseCase extends UseCase {
  #fromDraftParamToRequestDraftValueObjectMapper
  #getCurrentUserService
  #publishDraftService
  #updateCurrentUserRequestFactory
  #updateCurrentUserService

  constructor({config}) {
    super()
    this.#publishDraftService = DraftServicesFactory.publishDraftService({config})
    this.#fromDraftParamToRequestDraftValueObjectMapper =
      DraftMappersFactory.fromDraftParamToRequestDraftValueObjectMapper({
        config
      })
    this.#getCurrentUserService = UserServicesFactory.getCurrentUserService({
      config
    })
    this.#updateCurrentUserRequestFactory = UserRequestsFactory.updateCurrentUserRequest
    this.#updateCurrentUserService = UserServicesFactory.updateCurrentUserService({
      config
    })
  }

  static create({config}) {
    return new PublishAdPublisherUseCase({config})
  }

  @tracer({metric: 'PublishAdPublisherUseCase#execute'})
  @inlineError
  async execute({
    adId,
    categoryId,
    fields,
    images,
    userId,
    // ff_web_seller_get_available_free_ads_on_publish_my_ad_page
    isGetAvailableFreeAdsEnabled
  }) {
    const requestDraftVO = this.#fromDraftParamToRequestDraftValueObjectMapper
      .setFields(fields)
      .setDraftId(adId)
      .setImages(images)
      .setUserId(userId)
      .map()

    const [error, response] = await this.#publishDraftService.execute({
      categoryId,
      requestDraftVO,
      // ff_web_seller_get_available_free_ads_on_publish_my_ad_page
      isGetAvailableFreeAdsEnabled
    })
    if (error) {
      return Promise.reject(error)
    }

    const userEntity = await this.#getCurrentUserService.execute()
    const userPhone = userEntity.getPhone()
    const userZipCode = userEntity.getZipCode()
    const {phone: draftPhone, zipCode: draftZipCode} = fields

    if (userPhone !== draftPhone || userZipCode !== draftZipCode) {
      const updateCurrentUserRequest = this.#updateCurrentUserRequestFactory({phone: draftPhone, zipCode: draftZipCode})
      await this.#updateCurrentUserService.execute({updateCurrentUserRequest})
    }

    return response.toJSON()
  }
}

export const factory = PublishAdPublisherUseCase.create
